// extracted by mini-css-extract-plugin
module.exports = {"bg":"ModalCard_bg__dKXq3","bg-bottom-right":"ModalCard_bg-bottom-right__32tBy","bg-noise":"ModalCard_bg-noise__1pVkK"};